import { Navigate, Outlet } from 'react-router-dom';
import { usePermission } from '@/hooks/usePermission';
import { ROUTES } from '@/constants/routes.constants';
import type { Role } from '@/constants/roles.constants';

interface RequirePermissionProps {
  roles: Role[];
}

export function RequirePermission({ roles }: RequirePermissionProps) {
  const { hasAnyRole } = usePermission();

  if (!hasAnyRole(roles)) {
    return <Navigate to={ROUTES.UNAUTHORIZED} replace />;
  }

  return <Outlet />;
}
